import {useQuery} from '@tanstack/react-query'

import type {StoreSearchParams} from '@/lib/food/foodModel'
import {getStoreByAddress} from '@/lib/food/foodService'
import {FoodSearchFocus, FoodSort, FoodStoreType} from '@/lib/food/types'
import {NO_REFETCH_OPTIONS} from '@/utils/query/constants'

const useGetStores = (params: StoreSearchParams) => {
  return useQuery({
    queryKey: ['stores', params],
    queryFn: async ({signal}) =>
      getStoreByAddress({
        query: params.query ?? '',
        longitude: params.longitude,
        latitude: params.latitude,
        store_type: params.store_type ?? FoodStoreType[''],
        user_street_num: params.user_street_num ?? '',
        user_street_name: params.user_street_name ?? '',
        user_city: params.user_city ?? '',
        user_state: params.user_state ?? '',
        user_zipcode: params.user_zipcode ?? '',
        user_country: params.user_country ?? '',
        pickup: params.pickup ?? false,
        fetch_quotes: params.fetch_quotes ?? false,
        sort: params.sort ?? FoodSort.Relevance,
        open: params.open ?? false,
        search_focus: params.search_focus ?? FoodSearchFocus.Store,
        default_quote: params.default_quote ?? false,
        include_utc_hours: params.include_utc_hours ?? false,
        use_new_db: params.use_new_db ?? false,
        signal,
      }),
    ...NO_REFETCH_OPTIONS,
  })
}

export default useGetStores
